import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import SegmentOutlinedIcon from "@mui/icons-material/SegmentOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SpokeIcon from "@mui/icons-material/Spoke";

import CommonLayout from "../Common/Layout";
import { SmallTile } from "../Common/Tile";
import Toolbar from "../Common/Toolbar";

const useStyles = makeStyles()((theme) => ({
  PanelContainer: {
    padding: "10px 30px 30px 30px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
}));

const auditHistory = "/reports/audit-history";
const hostedAppUsage = "/reports/hosted-app-usage";
const sageMaker = "/reports/sagemaker-usage";
const snowflakeUsage = "/reports/snowflake-usage";
const jobEngine = "/reports/job-engine";
const dataAI = "/reports/data-ai";
const workspaceAccess = "/reports/workspace-access";

const breadcrumbArr = [{ link: "#", displayName: "Reports", active: true }];

const adminTiles = [
  {
    icon: <CloudDoneOutlinedIcon fontSize="large" />,
    label: "Hosted App Usage",
    link: hostedAppUsage,
    value: "",
    bgcolor: "#C4E1F6",
    color: "#54b7ff",
    dataId: "HostedAppUsage",
  },
  {
    icon: <SegmentOutlinedIcon fontSize="large" />,
    label: "SageMaker Usage",
    link: sageMaker,
    value: "",
    bgcolor: "#FFE4B5",
    color: "#FFA07A",
    dataId: "SageMakerUsage",
  },
  {
    icon: <AnalyticsOutlinedIcon fontSize="large" />,
    label: "Snowflake Usage",
    link: snowflakeUsage,
    value: "",
    bgcolor: "#AFEEEE",
    color: "#008B8B",
    dataId: "SnowflakeUsage",
  },
  {
    icon: <AccountTreeOutlinedIcon fontSize="large" />,
    label: "Job Engine Usage",
    link: jobEngine,
    value: "",
    bgcolor: "#E3F2C1",
    color: "#99A98F",
    dataId: "JobEngineUsage",
  },
  {
    icon: <AutoAwesomeIcon fontSize="large" />,
    label: "Data AI Usage",
    link: dataAI,
    value: "",
    bgcolor: "#E5CCCC",
    color: "#b7793d",
    dataId: "DataAIUsage",
  },
  {
    icon: <SpokeIcon fontSize="large" />,
    label: "Workspace Access",
    link: workspaceAccess,
    value: "",
    bgcolor: "#EBDEBE",
    color: "#b7793d",
    dataId: "WorkspaceAccess",
  },
];

const Reports = () => {
  const { classes } = useStyles();

  const user = useSelector((state) => state.user);
  const { Roles } = user.currentUser;

  return (
    <CommonLayout title="Reports" breadcrumbArr={breadcrumbArr}>
      <Container maxWidth="xl" sx={{ m: 0 }} className={classes.PanelContainer}>
        <Toolbar title="Reports" helpText="Reports" />

        <Grid container spacing={5} direction="row">
          <SmallTile
            {...{
              icon: <FeedOutlinedIcon fontSize="large" />,
              label: "Audit History",
              link: auditHistory,
              value: "",
              bgcolor: "#D0D0F7",
              color: "#2F4F4F",
              dataId: "AuditHistory",
            }}
          />
          {(Roles.includes("SysAdmin") || Roles.includes("BusinessAdmin")) &&
            adminTiles.map((item) => <SmallTile key={item.dataId} {...item} />)}
        </Grid>
      </Container>
    </CommonLayout>
  );
};

export default Reports;
